import { render, staticRenderFns } from "./ProjectDependencyGraph.vue?vue&type=template&id=46d95520&"
import script from "./ProjectDependencyGraph.vue?vue&type=script&lang=js&"
export * from "./ProjectDependencyGraph.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDependencyGraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports